<template>
  <section class="dflexr-jcs merchant-card">

    <div class="dflexc-jcs mCard-left" v-if="mqCurrent === 'lg'">
      <div class="dflexr-jcs merchant-meta-data" >
        <merchant-stat-card :merchant="xMerchant"/>
        <merchant-personal-data :merchant="xMerchant"/>
      </div>
      <merchant-item-table :merchant="xMerchant"/>

      <div class="dflexc-jcs mCard-right">

      </div>
    </div>

    <div class="dflexr-jcs mCard-left" v-if="mqCurrent === 'xl'">
      <div class="dflexc-jcs mCard-inner-left">
        <div class="dflexr-jcs merchant-meta-data" >
          <merchant-stat-card :merchant="xMerchant"/>
          <merchant-personal-data :merchant="xMerchant"/>
        </div>
        <merchant-item-table :merchant="xMerchant"/>
      </div>
      <div class="dflexc-jcs mCard-right">

      </div>

    </div>



  </section>
</template>

<style scoped lang="scss">
@import '@/assets/styles/marketplace/sm.scss';
@import '@/assets/styles/marketplace/md.scss';
@import '@/assets/styles/marketplace/lg.scss';
@import '@/assets/styles/marketplace/xl.scss';
</style>

<script setup>
import {computed, inject, onMounted, onUnmounted, onUpdated, ref} from "vue";
import MerchantStatCard from "@/components/marketplace/MerchantStatCard.vue";
import MerchantPersonalData from "@/components/marketplace/MerchantPersonalData.vue";
import MerchantItemTable from "@/components/marketplace/MerchantItemTable.vue"

const props = defineProps(['merch_idx', 'mp_idx', 'merchant'])
const mp = inject('mp_pkg')

const isMdUp = ref(false)
const isLgUp = ref(false)
const isXlUp = ref(false)

let mqMd, mqLg, mqXl

const mqCurrent = ref('sm')

const xMerchant = computed(() => {
  // debugger
  let mIdx = mp.active_merchant_idx[mp.active_mp]
  if(mp.active_merchant_idx[mp.active_mp] >= mp.list[mp.active_mp].merchants.length)
    mIdx = 0
  // return mp.list[props.mp_idx].merchants[active_merch_idx.value]
  return mp.list[mp.active_mp].merchants[mIdx]
})

 function updateBreakpoint() {
   if (!mqMd || !mqLg || !mqXl) return

   console.log('updateBreakpoint')
   // Check largest → smallest for exclusivity
   if (mqXl.matches) mqCurrent.value = 'xl'
   else if (mqLg.matches) mqCurrent.value = 'lg'
   else if (mqMd.matches) mqCurrent.value = 'md'
   else mqCurrent.value = 'sm'
   console.log('isMdUp:', isMdUp.value)
   console.log('isLgUp:', isLgUp.value)
   console.log('isXlUp:', isXlUp.value)
 }

function addMqlListener(mql, handler) {
  if (mql.addEventListener) mql.addEventListener('change', handler)
  else if (mql.addListener) mql.addListener(handler)

}

function removeMqlListener(mql, handler) {
  if (!mql) return
  if (mql.removeEventListener) mql.removeEventListener('change', handler)
  else if (mql.removeListener) mql.removeListener(handler)

}


onMounted(() => {
  console.log('MerchantCard')
  mqMd = window.matchMedia('(min-width: 480px)')
  mqLg = window.matchMedia('(min-width: 1024px)')
  mqXl = window.matchMedia('(min-width: 1440px)')

  updateBreakpoint()

  addMqlListener(mqMd, updateBreakpoint)
  addMqlListener(mqLg, updateBreakpoint)
  addMqlListener(mqXl, updateBreakpoint)


})

onUnmounted(()=> {
  removeMqlListener(mqMd, updateBreakpoint)
  removeMqlListener(mqLg, updateBreakpoint)
  removeMqlListener(mqXl, updateBreakpoint)


})

</script>
